class DeferredMediaStory extends HTMLElement {
  constructor() {
    super();

    // Logica per DeferredMedia
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener('click', () => this.loadContent());
    }

    // Logica per DeferredMediaStory
    window.addEventListener('resize', this.updateVideoDimensions.bind(this));
    document.addEventListener('DOMContentLoaded', this.updateVideoDimensions.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();

    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }

    this.updateVideoDimensions(); // Aggiorna le dimensioni del video dopo il caricamento
  }

  calculateContentDimensions(containerWidth, containerHeight, contentRatio) {
    const containerRatio = containerWidth / containerHeight;

    if (contentRatio < 1 && containerRatio < 1) {
      return {
        width: `${containerWidth}px`,
        height: `${containerWidth / contentRatio}px`,
        offsetX: '0px',
        offsetY: '0px',
      };
    }
    if (contentRatio > 1 && containerRatio > 1) {
      return {
        width: `${containerHeight * contentRatio}px`,
        height: `${containerHeight}px`,
        offsetX: `${(containerWidth - containerHeight * contentRatio) / 2}px`,
        offsetY: '0px',
      };
    }
    if (contentRatio < 1 && containerRatio > 1) {
      return {
        width: `${containerHeight * contentRatio}px`,
        height: `${containerHeight}px`,
        offsetX: `${(containerWidth - containerHeight * contentRatio) / 2}px`,
        offsetY: '0px',
      };
    }
    if (contentRatio > 1 && containerRatio < 1) {
      return {
        width: `${containerWidth}px`,
        height: `${containerWidth / contentRatio}px`,
        offsetX: '0px',
        offsetY: '0px',
      };
    }
    return {
      width: `${containerWidth}px`,
      height: `${containerHeight}px`,
      offsetX: '0px',
      offsetY: '0px',
    };
  }

  updateVideoDimensions() {
    const videoIframe = this.querySelector('iframe');
    if (!videoIframe) return;

    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 767;
    const isTablet = screenWidth >= 768 && screenWidth <= 1023;
    const isDesktop = screenWidth > 1023;

    const videoId = isMobile
      ? this.getAttribute('data-video-mobile-id')
      : this.getAttribute('data-video-desktop-id');

    const videoSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&autopause=0&controls=0`;

    if (this.getAttribute('data-media-id') !== videoId) {
      this.setAttribute('data-media-id', videoId);
    }

    if (videoIframe.getAttribute('src') !== videoSrc) {
      videoIframe.setAttribute('src', videoSrc);
    }

    const ratioDesktop = this.getAttribute('data-ratio-desktop').split(':');
    const ratioMobile = this.getAttribute('data-ratio-mobile').split(':');
    const ratio = isMobile ? ratioMobile[0] / ratioMobile[1] : ratioDesktop[0] / ratioDesktop[1];

    if (isTablet) {
      videoIframe.style.height = '100vh';
      videoIframe.style.width = `calc(100vh * ${ratio})`;
      videoIframe.style.left = `calc(50% - (100vh * ${ratio}) / 2)`;
      videoIframe.style.top = '0px';
      videoIframe.style.position = 'relative';
    } else if (isDesktop) {
      const heightPctOnViewport = 1.125;
      const containerWidth = window.innerWidth;
      const containerHeight = containerWidth * heightPctOnViewport;
      const dimensions = this.calculateContentDimensions(containerWidth, containerHeight, ratio);

      videoIframe.style.width = dimensions.width;
      videoIframe.style.height = dimensions.height;
      videoIframe.style.left = dimensions.offsetX;
      videoIframe.style.top = dimensions.offsetY;
    } else {
      const containerWidth = window.innerWidth;
      const dimensions = {
        width: `${containerWidth}px`,
        height: '100vh',
        offsetX: '0px',
        offsetY: '0px',
      };

      videoIframe.style.width = dimensions.width;
      videoIframe.style.height = dimensions.height;
      videoIframe.style.left = dimensions.offsetX;
      videoIframe.style.top = dimensions.offsetY;
    }
  }
}

customElements.define('deferred-media-story', DeferredMediaStory);